
const style = (theme) => {
  const output = {
    root: {
      minHeight: '100vh',
    },
    content: {
      background: theme.colors[1],
      color: theme.colors[0],
    },
    wrapper: {
      extend: theme.wrapper,
    },
    description: {
      extend: theme.wrapper,
      paddingTop: 200,
      paddingBottom: 200,
    },
    galleryWrapper: {
      marginTop: 100,
      marginBottom: 100,
    },
    products: {
      paddingTop: 50,
    },
    productsTitle: {
      textTransform: 'uppercase',
      fontSize: 24,
      marginBottom: 50,
    },
  }

  /*------------------------------
  SM
  ------------------------------*/
  output[theme.mediaInverse.sm] = {
    description: {
      paddingTop: 50,
      paddingBottom: 50,
    },
    productsTitle: {
      fontSize: 16,
      marginBottom: 20,
    },
  }

  return output
}

export default style
